import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let FadeDown = document.querySelectorAll(".fade-down");

if (FadeDown.length > 0) {
    FadeDown.forEach((element) => {

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: 'bottom bottom',
                once: true,
            }
        });

        tl.from(element, {
            opacity: 0,
            duration: 0.75,
            y: -100,
        });
    });
}